// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"1bef8321","787":"75a04df9"}[chunkId] + ".chunk.js";
};